import React from 'react';
import Atl from '../../../static/icons/_inline-svg/clubs/atl.svg';
import Fcp from '../../../static/icons/_inline-svg/clubs/fcp.svg';
import Fpf from '../../../static/icons/_inline-svg/clubs/fpf.svg';
import Scp from '../../../static/icons/_inline-svg/clubs/scp.svg';
import Slb from '../../../static/icons/_inline-svg/clubs/slb.svg';
// import Spain from '../../../static/icons/_inline-svg/clubs/spain.svg';
// import ClubAmerica from '../../../static/icons/_inline-svg/clubs/club_america.svg';
import Brazil from '../../../static/icons/_inline-svg/clubs/brazil.svg';
import Valencia from '../../../static/icons/_inline-svg/clubs/valencia.svg';
import Psg from '../../../static/icons/_inline-svg/clubs/psg.svg';
import Vasco from '../../../static/icons/_inline-svg/clubs/vasco_da_gama.svg';
import West from '../../../static/icons/_inline-svg/clubs/west_ham.svg';
import Marseille from '../../../static/icons/_inline-svg/clubs/marseille.svg';

const FootballClubsSection = () => {
    return (
        <section id="football-clubs">
            <div className="flex flex-col md:flex-row md:items-center space-y-6 md:space-y-0 md:space-x-20">
                <span className="text-14 text-card-text-color min-w-max">
                    Football clubs using FanCollex®
                </span>
                <div className="clubs-container flex md:items-center justify-between md:justify-around md:w-2/3">
                    <Fpf className="h-16" />
                    <Scp className="h-16" />
                    <Slb className="h-16" />
                    <Fcp className="h-16" />
                    {/* <Spain className="h-16" /> */}
                    <Atl className="h-16" />
                    <Valencia className="h-16" />
                    {/* <ClubAmerica className="h-16" /> */}
                    <Brazil className="h-16" />
                    <Psg className="h-16" />
                    <Marseille className="h-16" />
                    <West className="h-16" />
                    <Vasco className="h-16" />
                </div>
            </div>
        </section>
    );
};

export default FootballClubsSection;
